{
  "id": "campaign-067",
  "name": "Clover Course",
  "seed": "campaign:67",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".,........_,",
    ",,,ooo...._.",
    ".,.oFoss.._,",
    "..booo#s.b_.",
    "x........._.",
    "..,.W..W.._.",
    ".,.,...,.._.",
    "..www.,,,._.",
    "..www.#,.._.",
    ".........._.",
    ".........._.",
    "x.h......h_.",
    "....W..W.._.",
    "...T....T._.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 5
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 9
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 0
    }
  ],
  "moles": {
    "hills": 2,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 67,
  "biome": "golf",
  "par": {
    "reel": 7230,
    "push": 5591,
    "selfPropelled": 5394,
    "tractor": 4415,
    "zeroTurn": 3492,
    "fairway": 2426
  },
  "routeTries": {
    "par": {
      "reel": 22,
      "push": 20,
      "selfPropelled": 6,
      "tractor": 0,
      "zeroTurn": 1,
      "fairway": 17
    }
  }
}
